<template>
  <div>
    <v-row
      justify="center"
      class="pa-1"
      style="margin-bottom:55px;"
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        class="pa-0"
      >
        <div
          v-if="reviews_size===0"
          class="text-center ma-5"
          style="font-size:20px;"
        >
          No photos have been posted yet.
        </div>
        <div
          v-else
        >
          <v-tabs
            centered
            class="px-3 py-1 rounded-5"
            :color="site_color"
            style="border-radius:10px; background-color:#fff;"
          >
            <v-tab>
              <v-icon
                size="25"
                :color="site_color"
              >
                mdi-camera
              </v-icon>
            </v-tab>
            <v-tab>
              <v-icon
                size="25"
                :color="site_color"
              >
                mdi-comment-text-outline
              </v-icon>
            </v-tab>
            <v-tab-item>
              <v-container fluid>
                <v-row>
                  <v-col
                    v-for="item in review_images"
                    :key="item"
                    cols="6"
                    md="4"
                    class="d-flex child-flex pa-1"
                  >
                    <v-img
                      :src="item"
                      :lazy-src="item"
                      aspect-ratio="1"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-row
                class="pa-1"
                style="margin-bottom:55px;"
              >
                <v-col
                  v-for="(item,key) in reviews"
                  :key="key"
                  cols="12"
                  sm="4"
                  md="4"
                  class="pa-1"
                >
                  <v-card
                    class="ma-3 pa-0"
                  >
                    <v-img
                      v-show="item.review_image_url"
                      :src="item.review_image_url"
                      aspect-ratio="1"
                    />
                    <v-card-text
                      class="px-3 py-3"
                      style="font-size:24px"
                    >
                      {{ item.review_title }}
                    </v-card-text>
                    <v-card-text
                      class="px-3 py-1"
                      style="font-size:16px"
                    >
                      {{ item.createdAt.toDate().toLocaleString('ja-JP').slice( 0, -3 ) }} by {{ item.review_nickname }}
                    </v-card-text>
                    <v-card-text
                      class="px-3 py-1"
                      style="font-size:16px"
                    >
                      {{ item.review_description }}
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-col>
    </v-row>
    <v-btn
      style="bottom: 100px"
      :color="site_color"
      absolute
      right
      fab
      fixed
      x-large
    >
      <review-modal-form
        justify="start"
        icon="mdi-pencil"
        card_title="Share your product experience."
        @review-added-event="reviewDisplay"
      />
    </v-btn>
  </div>
</template>
<script>
  import { db } from '../../plugins/firebase.js'
  export default {
    name: 'Review',
    components: {
      ReviewModalForm: () => import('./ReviewModalForm.vue'),
    },
    data: () => ({
      tab: null,
      reviews: [],
      review_images: [],
      reviews_size: 1,
      site_color: '',
    }),
    created () {
      this.reviewDisplay()
    },
    methods: {
      reviewDisplay: function () {
        this.site_color = this.$store.state.site_color
        this.reviews = [] // 呼び出される度に一度空にする
        this.review_images = []
        db.collection('partners').doc(this.$store.state.partner_id).collection('sites').doc(this.$store.state.site_id).collection('reviews').orderBy('createdAt', 'desc').get().then((snapshot) => {
          this.reviews_size = snapshot.size
          snapshot.forEach((reviewDoc) => {
            const review = reviewDoc.data()
            if (review.is_display === true) {
              this.reviews.push(review)
            }
            if (review.review_image_url && review.is_display === true) {
              this.review_images.push(review.review_image_url)
            }
          })
        }).catch(error => {
          console.log(error)
        })
      },
    },
  }
</script>

<style lang="scss">
  .main {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  .bottom-float {
    margin-top: auto;
    font-size: 100px;
  }
</style>
